import * as React from 'react';
const classnames = require('classnames')
import './styles.scss';

import { KEY_CODES } from '../../common/constants';
import Icon from '../../icons';
import { isMobile } from '../../common/util';



export default class EditableHeading extends React.Component {
    editRef;
    constructor(props) {
        super(props);

        this.state = {
            isEditMode: false,
            inputText: null,
            setVisible: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    render() {
        return (
            <div ref={(node) => { this.editRef = node }}>
                {
                    this.state.isEditMode
                        ? (!this.props.ListingComponent) ? this.renderEditableHeader() : this.renderEditableHeaderForFileCaption()
                        : (!this.props.ListingComponent) ? this.renderHeader() : this.renderFileCaptionHeader()
                }
            </div>);

    }
    UNSAFE_componentWillReceiveProp(newProps) {
        if (newProps.isOpen !== undefined || newProps.isOpen !== null) {
            this.setState({
                isEditMode: this.props.isOpen,
            })
        }

    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
        if (this.props.isOpen !== undefined || this.props.isOpen !== null) {
            this.setState({
                isEditMode: this.props.isOpen,
                inputText: this.props.heading
            })
        }
    }
    componentDidUpdate(prevProps,preState){
        if (preState.isEditMode && preState.isEditMode != this.state.isEditMode) {
            this.setState({
                isEditMode: false
            });
            if (this.props.editableHeadingCancelClick) {
                this.props.editableHeadingCancelClick();
            }
        }

    }
    handleOutsideClick(event) {
        if (this.editRef && !this.editRef.contains(event.target)) {
            this.setState({
                isEditMode: false
            });
        }
    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick)
    }

    renderEditableHeaderForFileCaption() {
        const headerClassNames = { 'addValue': true };
        return (
            <div className={classnames(headerClassNames)} >
                <div className="formGroup">
                <input
                    autoFocus
                    type="text"
                    value={this.state.inputText}
                    placeholder={"Add caption..."}
                    maxLength={this.props.maxLength}
                    onChange={this.handleInputChange}
                    onKeyDown={(event) => {
                        if (event.keyCode === KEY_CODES.ENTER) {
                            this.onSaveClick(event);
                        }
                    }} />
                <span onClick={this.onCancelClick} ><Icon name="close" className="icon close" /></span>
                <span onClick={this.onSaveClick}><Icon name="check" className="icon activeIcon check" /></span>
                </div>
            </div>
        )
    }
    
    renderEditableHeader() {
        const headerClassNames = {
            'editable-header': true,
            'is-edit': true,
            'editable': this.props.isEditable,
            "rowSpaceBetween": true,
        };
        return (
            <div className={ isMobile()?  "mobileView":classnames(headerClassNames) }>
                <input
                    style=  {isMobile() ? {  maxWidth : 240}: {}}
                    autoFocus
                    type="text"
                    value={this.state.inputText}
                    onChange={this.handleInputChange}
                    onKeyDown={(event) => {
                        if (event.keyCode === KEY_CODES.ENTER) {
                            this.onSaveClick(event);
                        }
                    }} />
                
                <div className="alignMiddle editableDiaries">
                    <span className="statusCheck" onClick={(this.state.setVisible) ? this.onSaveClick : null }><Icon name="check" className={(this.state.setVisible) ? 'icon activeIcon check mr' : 'icon disabled check mr'}/></span>
                    <span onClick={ this.onCancelClick } ><Icon name="close" className="icon close"/></span>
                </div>
            </div >
        );
    }

    renderFileCaptionHeader() {
        return (
            <label className={this.props.heading ? 'editValue captionSaved' : "editValue"} onClick={this.onEditClick}>{(this.props.heading) ? this.props.heading : 'Add caption...'}</label>
        )
    }

    renderHeader() {
        const headerClassNames = {
            // 'editable-header': true,
            'editable': this.props.isEditable3,
            'alignMiddle': true,
            'mr': true,

        };

        return (
            <div className={classnames(headerClassNames)}>
                <span style=  {isMobile() ? {  maxWidth : 70}: {}} className="mr" onClick={this.props.onHeadingClick ? this.props.onHeadingClick : () => false}>{this.props.heading}</span>
                <span className="iconRipple" onClick={this.onEditClick}><Icon name="editActive" className="icon" /></span>
            </div>
        );
    }

    handleInputChange(event) {
        if(event.target.value != this.props.heading) {
            this.setState({
                setVisible: true
            });
        }
        this.setState({
            inputText: event.target.value
        });
    }

    onSaveClick(event) {
        if (this.props.isOpen === undefined || this.props.isOpen === null) {
            this.setState({
                isEditMode: false
            });
        }
        if (this.state.inputText.trim() == "") {
            this.setState({
                isEditMode: false
            });
            if (this.props.allowBlank)
                this.props.onHeadingEdited(this.state.inputText.toString().trim(), this.props.id);
        }
        else {
            this.props.onHeadingEdited(this.state.inputText.toString().trim(), this.props.id);
        }
    }

    onCancelClick(event) {
        this.setState({
            isEditMode: false
        });
        if (this.props.editableHeadingCancelClick) {
            this.props.editableHeadingCancelClick();
        }
    }

    onEditClick(event) {
        this.setState({
            isEditMode: true,
            inputText: this.props.heading
        });
    }
}